import { useState } from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, XMarkIcon } from '@heroicons/react/24/outline';

const navLink = 'rounded-lg px-3 py-2 text-sm font-medium text-slate-700 transition-colors hover:bg-slate-100 hover:text-slate-950 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-700 focus-visible:ring-offset-2';

export default function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-40 border-b border-slate-200/80 bg-white/95 backdrop-blur">
      <div className="container-centered">
        <div className="flex h-16 items-center justify-between gap-3">
          <Link to="/" className="flex min-w-0 items-center gap-2.5 rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-700 focus-visible:ring-offset-2" onClick={closeMobileMenu}>
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary-800 font-serif text-lg font-semibold text-white" aria-hidden="true">
              B
            </span>
            <span className="truncate font-serif text-lg font-semibold tracking-tight text-slate-950 sm:text-xl">
              Business First Bank
            </span>
          </Link>

          <nav className="hidden items-center gap-1 md:flex" aria-label="Primary">
            <Link to="/" className={navLink}>
              Open Account
            </Link>
            <Link to="/applicants" className={navLink}>
              Applicants
            </Link>
            <Link to="/accounts" className={navLink}>
              Accounts
            </Link>
            <Link to="/wire-transfers" className={navLink}>
              Wire Transfers
            </Link>
          </nav>

          <div className="hidden items-center gap-2 text-sm text-slate-600 lg:flex">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" />
            <span>1-800-BANK-123</span>
            <span className="text-slate-300" aria-hidden="true">·</span>
            <span>24/7 Support</span>
          </div>

          <div className="md:hidden">
            <button
              type="button"
              onClick={toggleMobileMenu}
              className="inline-flex h-11 w-11 items-center justify-center rounded-lg text-slate-800 hover:bg-slate-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-700"
              aria-label="Toggle menu"
              aria-expanded={isMobileMenuOpen}
            >
              {isMobileMenuOpen ? (
                <XMarkIcon className="h-6 w-6" />
              ) : (
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>
        </div>

        {isMobileMenuOpen && (
          <div className="border-t border-slate-200 bg-white md:hidden">
            <nav className="flex flex-col gap-1 py-3" aria-label="Primary">
              <Link to="/" onClick={closeMobileMenu} className="rounded-lg px-3 py-3 text-base font-medium text-slate-800 hover:bg-slate-50">
                Open Account
              </Link>
              <Link to="/applicants" onClick={closeMobileMenu} className="rounded-lg px-3 py-3 text-base font-medium text-slate-800 hover:bg-slate-50">
                Applicants
              </Link>
              <Link to="/accounts" onClick={closeMobileMenu} className="rounded-lg px-3 py-3 text-base font-medium text-slate-800 hover:bg-slate-50">
                Accounts
              </Link>
              <Link to="/wire-transfers" onClick={closeMobileMenu} className="rounded-lg px-3 py-3 text-base font-medium text-slate-800 hover:bg-slate-50">
                Wire Transfers
              </Link>
            </nav>
            <div className="space-y-2 border-t border-slate-200 px-3 py-4 text-sm text-slate-600">
              <p>1-800-BANK-123</p>
              <p>24/7 Support</p>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
